import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import BaseComponent from '../../../base.component';
import { FilterResponse } from 'src/app/shared/models/filter-response';

@Component({
    selector: 'cdp-multi-select',
    templateUrl: './multi-select.component.html',
    styleUrls: ['./multi-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MultiSelectComponent<TItemType, TBindValueType> extends BaseComponent implements OnInit {
    @Input() clearable = true;
    @Input() loading?: boolean;
    @Input() placeholder: string;
    @Input() tooltip?: string;
    @Input() controlName: string;
    @Input() bindLabel: string;

    private _selections: ReadonlyArray<TBindValueType>;
    get selections(): ReadonlyArray<TBindValueType> {
        return this._selections;
    }
    @Input()
    set selections(value: ReadonlyArray<TBindValueType>) {
        if (value !== this._selections) {
            this._selections = value;
            this.selectedItemsControl.setValue(value);
        }
    }

    mutableItems: TItemType[];

    get items(): ReadonlyArray<TItemType> {
        return this.mutableItems;
    }
    @Input()
    set items(value: ReadonlyArray<TItemType>) {
        this.mutableItems = [...value];
    }

    @Output() selectionChange: EventEmitter<FilterResponse<TBindValueType>> = new EventEmitter<
        FilterResponse<TBindValueType>
    >();

    readonly selectedItemsControl: FormControl = new FormControl([]);
    readonly multiSelectGroup = new FormGroup({
        selectedItemsControl: this.selectedItemsControl
    });

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.selectedItemsControl.valueChanges
            .pipe(this.unsubscribeOnDestroy())
            .subscribe((selections: ReadonlyArray<TBindValueType>) => {
                if (this.selections !== selections) {
                    this.selections = selections;
                    const response: FilterResponse<TBindValueType> = {
                        name: this.controlName,
                        selection: [...selections]
                    };
                    this.selectionChange.emit(response);
                }
            });
    }
}
